import { Observable } from '../../Observable';
import { _throw } from '../../observable/throw';

Observable.throw = _throw;


// WEBPACK FOOTER //
// ./~/rxjs/src/add/observable/throw.ts